import roles from './roles/de-roles';
export default {
    app: {
        title: 'Blood on the Clocktower',
        subtitle: 'Trouble Brewing',
    },
    nav: {
        overview: 'Übersicht',
        myRole: 'Meine Rolle',
        rules: 'Regeln',
        info: 'Info',
    },
    common: {
        search: 'Suchen...',
        filter: 'Filtern',
        save: 'Speichern',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        close: 'Schließen',
        select: 'Auswählen',
        notes: 'Notizen',
        day: 'Tag',
        night: 'Nacht',
    },
    roleTypes: {
        townsfolk: 'Dorfbewohner',
        outsider: 'Außenseiter',
        minion: 'Handlanger',
        demon: 'Dämon',
    },
    overview: {
        title: 'Rollen-Übersicht',
        filterByType: 'Nach Typ filtern',
        allRoles: 'Alle Rollen',
    },
    myRole: {
        title: 'Meine Rolle',
        selectRole: 'Wähle deine Rolle',
        noRoleSelected: 'Keine Rolle ausgewählt',
        ability: 'Fähigkeit',
        relevantRules: 'Relevante Regeln',
        myNotes: 'Meine Notizen',
        writeNote: 'Notiz hinzufügen...',
    },
    gameTracker: {
        title: 'Spielverlauf',
        currentDay: 'Aktueller Tag',
        phase: 'Phase',
        players: 'Spieler',
        addPlayer: 'Spieler hinzufügen',
        playerName: 'Spieler-Name',
        alive: 'Lebendig',
        dead: 'Tot',
        usedAbility: 'Fähigkeit genutzt',
    },
    rules: {
        title: 'Spielregeln',
        fullRules: 'Vollständige Regeln',
        overview: {
            title: 'Übersicht',
            description: 'Blood on the Clocktower ist ein soziales Deduktionsspiel für 5-15 Spieler. In "Trouble Brewing" kämpfen die guten Dorfbewohner gegen das Böse, vertreten durch Dämonen und ihre Handlanger.',
        },
        setup: {
            title: 'Spielaufbau',
            content: `
        <p><strong>Rollenverteilung:</strong></p>
        <ul>
          <li>Der Spielleiter verteilt die Rollen geheim an alle Spieler</li>
          <li>Jeder Spieler erhält eine Rolle und erfährt seine Fähigkeit</li>
          <li>Die Zusammensetzung hängt von der Spielerzahl ab</li>
        </ul>
        <p><strong>Erste Nacht:</strong></p>
        <ul>
          <li>Alle Spieler schließen die Augen</li>
          <li>Der Spielleiter weckt einzelne Rollen in bestimmter Reihenfolge</li>
          <li>Jede Rolle führt ihre Nachtaktion aus</li>
        </ul>
      `,
        },
        gameplay: {
            title: 'Spielablauf',
            content: `
        <p>Das Spiel wechselt zwischen Tag- und Nachtphasen:</p>
        <p><strong>Tagphase:</strong></p>
        <ul>
          <li>Alle lebenden Spieler diskutieren und tauschen Informationen aus</li>
          <li>Spieler können nominieren und abstimmen</li>
          <li>Der nominierte Spieler mit den meisten Stimmen wird hingerichtet</li>
          <li>Ein toter Spieler darf einmal im Spiel noch abstimmen</li>
        </ul>
        <p><strong>Nachtphase:</strong></p>
        <ul>
          <li>Der Dämon tötet einen Spieler</li>
          <li>Verschiedene Rollen führen ihre Fähigkeiten aus</li>
          <li>Am Morgen wird bekannt gegeben, wer gestorben ist</li>
        </ul>
      `,
        },
        winning: {
            title: 'Siegbedingungen',
            content: `
        <p><strong>Die Guten gewinnen wenn:</strong></p>
        <ul>
          <li>Der Dämon hingerichtet wird (durch Abstimmung am Tag)</li>
        </ul>
        <p><strong>Das Böse gewinnt wenn:</strong></p>
        <ul>
          <li>Nur noch 2 Spieler am Leben sind (1 Dämon + 1 anderer)</li>
          <li>Oder durch spezielle Fähigkeiten bestimmter böser Rollen</li>
        </ul>
      `,
        },
        abilities: {
            title: 'Fähigkeiten',
            content: `
        <p><strong>Arten von Fähigkeiten:</strong></p>
        <ul>
          <li><strong>Passive Fähigkeiten:</strong> Wirken automatisch</li>
          <li><strong>Nachtfähigkeiten:</strong> Werden nachts ausgeführt</li>
          <li><strong>Tagfähigkeiten:</strong> Können am Tag genutzt werden</li>
          <li><strong>Einmalige Fähigkeiten:</strong> Können nur einmal im Spiel genutzt werden</li>
        </ul>
        <p><strong>Wichtig:</strong></p>
        <ul>
          <li>Tote Spieler verlieren ihre aktiven Fähigkeiten</li>
          <li>Der Spielleiter kann falsche Informationen geben, wenn es die Spielmechanik erfordert</li>
          <li>Einige Fähigkeiten beeinflussen sich gegenseitig</li>
        </ul>
      `,
        },
        washerwoman: {
            1: 'Die Wäscherin erfährt in der ersten Nacht zwei Spieler, von denen einer eine bestimmte gute Rolle hat.',
            2: 'Diese Information kann durch betrunkene oder vergiftete Zustände falsch sein.',
        },
        librarian: {
            1: 'Der Bibliothekar erfährt in der ersten Nacht zwei Spieler, von denen einer ein Außenseiter ist.',
            2: 'Wenn kein Außenseiter im Spiel ist, erfährt der Bibliothekar eine "0".',
        },
        investigator: {
            1: 'Der Ermittler erfährt in der ersten Nacht zwei Spieler, von denen einer ein Handlanger ist.',
            2: 'Diese Information kann durch betrunkene oder vergiftete Zustände falsch sein.',
        },
        chef: {
            1: 'Böse Nachbarn zählen als Paar. Der Koch erfährt die Anzahl aller solcher Paare.',
        },
        empath: {
            1: 'Der Empath erfährt nur die Anzahl böser lebender Nachbarn, nicht deren Identität.',
        },
        fortuneteller: {
            1: 'Die Wahrsagerin erfährt nur "Ja" oder "Nein", nicht welcher der beiden Spieler der Dämon ist.',
            2: 'Der rote Hering ist ein guter Spieler, der immer als Dämon registriert, auch wenn er tot ist.',
        },
        undertaker: {
            1: 'Der Bestatter erfährt die wahre Rolle, nicht die vorgetäuschte.',
        },
        monk: {
            1: 'Der Mönch kann nicht sich selbst schützen. Geschützte Spieler können durch Hinrichtung sterben.',
        },
        ravenkeeper: {
            1: 'Der Rabenwächter wird nur geweckt, wenn er nachts stirbt, nicht bei Hinrichtung am Tag.',
        },
        virgin: {
            1: 'Nach der ersten Nominierung verliert die Jungfrau ihre Fähigkeit.',
        },
        slayer: {
            1: 'Der Dämonenjäger kann seine Fähigkeit nur einmal im Spiel nutzen, egal ob erfolgreich oder nicht.',
        },
        soldier: {
            1: 'Der Soldat kann durch Hinrichtung oder durch Fähigkeiten anderer böser Spieler sterben.',
        },
        mayor: {
            1: 'Der Bürgermeister ermöglicht einen Sieg durch Zeitablauf, wenn keine Hinrichtung stattfindet.',
        },
        butler: {
            1: 'Der Butler darf nicht abstimmen, wenn sein Herr nicht abstimmt.',
            2: 'Der Butler wählt jede Nacht neu seinen Herrn.',
        },
        drunk: {
            1: 'Der Betrunkene denkt, er ist eine andere Rolle. Der Spielleiter behandelt ihn wie diese Rolle.',
            2: 'Alle Informationen, die der Betrunkene erhält, sind falsch oder beliebig.',
        },
        recluse: {
            1: 'Der Einsiedler kann bei Fähigkeiten, die nach Alignment fragen, als böse erscheinen.',
        },
        saint: {
            1: 'Wenn der Heilige hingerichtet wird, endet das Spiel sofort mit einer Niederlage der Guten.',
        },
        poisoner: {
            1: 'Vergiftete Spieler erhalten falsche Informationen oder keine Wirkung ihrer Fähigkeiten.',
            2: 'Die Vergiftung endet am nächsten Abend automatisch.',
        },
        spy: {
            1: 'Der Spion sieht alle Informationen im Grimoire und alle Marker.',
            2: 'Der Spion kann als gut registrieren, wenn Fähigkeiten nach Alignment fragen.',
        },
        scarletwoman: {
            1: 'Die Scharlachrote Frau wird nur zum Dämon, wenn 5+ Spieler leben.',
            2: 'Wenn sie zum Dämon wird, verliert sie ihre alte Fähigkeit komplett.',
        },
        baron: {
            1: 'Der Baron fügt dem Setup 2 zusätzliche Außenseiter hinzu (ersetzt Dorfbewohner).',
        },
        imp: {
            1: 'Der Imp kann sich selbst töten, um einen Handlanger zum neuen Imp zu machen.',
            2: 'Wenn der Imp sich selbst tötet, stirbt er nicht, sondern ein Handlanger wird zum Imp.',
            3: 'Der Imp kann keinen Spieler mit der Soldat-Fähigkeit töten.',
        },
    },
    info: {
        title: 'Informationen',
        version: 'Version',
        about: 'Über diese App',
        aboutText: 'Diese App unterstützt dich beim Spielen von Blood on the Clocktower im Szenario "Trouble Brewing". Sie bietet Rollenbeschreibungen, Regeln und einen Spielverlauf-Tracker.',
        language: 'Sprache',
        credits: {
            title: 'Credits',
            game: 'Blood on the Clocktower ist ein Spiel von Steven Medway und The Pandemonium Institute.',
            design: 'Diese App wurde als Fan-Projekt erstellt und ist nicht offiziell lizenziert.',
        },
    },
    roles,
};
